import axios from 'axios'
import store from '../store'
import { AUTH_LOGOUT } from 'actions/authentication'

const http = axios.create({
	baseURL: process.env.VUE_APP_NODE_API_URL,
	headers: { 'Content-Type': 'application/json' },
})

http.all = axios.all
http.spread = axios.spread

http.interceptors.request.use(
	function (config) {
		const token = store.getters.token
		if (token) {
			config.headers.Authorization = token
			$.ajaxSetup({
				headers: { 'Authorization': token }
			})
		}

		return config
	},
	function (error) {
		return Promise.reject(error)
	},
)
http.interceptors.response.use((response) => {
	return response;
}, function (error) {
	// Do something with response error
	if (error.response) {
		if (error.response.status === 401) {
			store.dispatch(AUTH_LOGOUT).then(() => {
				document.location.href = '/'
			})
		} else {
			return Promise.reject(error.response);
		}
	}
});
export default http
